import { lazy } from 'react';

export const loginRoutes = [
  {
    page: 'Login',
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView')),
  },
  {
    page: 'Offline',
    path: '/offline',
    component: lazy(() => import('src/views/pages/OfflineView')),
  },
  {
    page: 'Forgot Password',
    path: '/forgot-password',
    component: lazy(() => import('src/views/auth/ForgotPasswordView')),
  },
  {
    page: 'Reset Password',
    path: '/reset-password',
    component: lazy(() => import('src/views/auth/ResetPasswordView')),
  },
  {
    page: 'Reset Password',
    path: '/reset-password/:tokenString',
    component: lazy(() => import('src/views/auth/ResetPasswordView')),
  },
];
